import React from "react";
import { SVGUniqueID } from "react-svg-unique-id";

export default (props) => {
  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M5 15C5 11.2288 5 9.34315 6.17157 8.17157C7.34315 7 9.22876 7 13 7H17C20.7712 7 22.6569 7 23.8284 8.17157C25 9.34315 25 11.2288 25 15V17C25 20.7712 25 22.6569 23.8284 23.8284C22.6569 25 20.7712 25 17 25H13C9.22876 25 7.34315 25 6.17157 23.8284C5 22.6569 5 20.7712 5 17V15Z"
          stroke="#363636"
          strokeWidth="1.5"
        />
        <path d="M10 7V5.5" stroke="#363636" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M20 7V5.5" stroke="#363636" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M5.5 12H24.5" stroke="#363636" strokeWidth="1.5" strokeLinecap="round" />
        <path
          d="M21 20C21 20.5523 20.5523 21 20 21C19.4477 21 19 20.5523 19 20C19 19.4477 19.4477 19 20 19C20.5523 19 21 19.4477 21 20Z"
          fill="#363636"
        />
        <path
          d="M21 16C21 16.5523 20.5523 17 20 17C19.4477 17 19 16.5523 19 16C19 15.4477 19.4477 15 20 15C20.5523 15 21 15.4477 21 16Z"
          fill="#363636"
        />
        <path
          d="M16 20C16 20.5523 15.5523 21 15 21C14.4477 21 14 20.5523 14 20C14 19.4477 14.4477 19 15 19C15.5523 19 16 19.4477 16 20Z"
          fill="#363636"
        />
        <path
          d="M16 16C16 16.5523 15.5523 17 15 17C14.4477 17 14 16.5523 14 16C14 15.4477 14.4477 15 15 15C15.5523 15 16 15.4477 16 16Z"
          fill="#363636"
        />
        <path
          d="M11 20C11 20.5523 10.5523 21 10 21C9.44772 21 9 20.5523 9 20C9 19.4477 9.44772 19 10 19C10.5523 19 11 19.4477 11 20Z"
          fill="#363636"
        />
        <path
          d="M11 16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16C9 15.4477 9.44772 15 10 15C10.5523 15 11 15.4477 11 16Z"
          fill="#363636"
        />
      </svg>
    </SVGUniqueID>
  );
};
